export const getBorderStyleProps = () => {
  return {
    borderBlockColor: 'text-core-default',
    borderInlineColor: 'text-core-default',
    borderBlockStyle: 'solid',
    borderInlineStyle: 'solid',
    borderBlockWidth: '100',
    borderInlineWidth: '100'
  };
};
export const getCircleShapeStyleProps = () => {
  return {
    borderStartStartRadius: 'full',
    borderStartEndRadius: 'full',
    borderEndStartRadius: 'full',
    borderEndEndRadius: 'full'
  };
};
export const getRoundedShapeStyleProps = () => {
  return {
    borderStartStartRadius: '100',
    borderStartEndRadius: '100',
    borderEndStartRadius: '100',
    borderEndEndRadius: '100'
  };
};